import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from "environments/environment";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'app/reusable/common.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CalamityStatusService } from '../../calamity-status.service';
import { CalamityService } from '../../calamity.service';
import { CALAMITY_KIND_DATA } from '../../constants/calamity-kind';
import { CalamityModel } from '../../models/calamity.model';
import { FormatWidth, getLocaleTimeFormat } from "@angular/common";
import * as moment from "moment-timezone";
import { IntakeService } from 'app/intake/intake-services/intake.service';
import { CedNotificationService } from 'ced-ng-library';
import * as cityTimezones from 'city-timezones'

@Component({
  selector: 'app-calamity-layout',
  templateUrl: './calamity-basic-details.component.html',
  styleUrls: ['./calamity-basic-details.component.scss']
})
export class CalamityBasicDetailsComponent implements OnInit, OnDestroy {

  @ViewChild("places", { static: true }) places: GooglePlaceDirective;
  private _subject$: Subject<boolean> = new Subject();
  public calamityForm = new FormGroup({});
  public serverUrlSlot1 : string = environment.Services.AlphaURLSlot1;
  public checkList = ["Yes","No"];
  public FiltredCheckList=[];
  public FiltredCheckListGT=[];
  public FiltredCheckListPL=[];
  public FiltredCheckListTTC=[];
  public countries =[];
  public calamityStatusGrid =[];
  public FiltredCalamityStatusGrid =[];
  public FiltredCalamityKindGrid =[];
  public calamityKindGrid =[];
  public calamityObject : CalamityModel = new CalamityModel() ;
  calamityLatitude : number ;
  calamityLongitude : number ;
  calamityId : string;
  calamityLocation : string;
  public localDate: string;
  location: string;
  public filteredCountries = [];

  constructor(
    private commonService: CommonService,
    private calamityService: CalamityService,
    private calamityStatusService : CalamityStatusService,
    public translateService : TranslateService,
    private cd: ChangeDetectorRef,
    private cedNotificationService: CedNotificationService,
    private router: Router,
    private fb : FormBuilder,
    private intakeService : IntakeService,
    @Inject(LOCALE_ID) public locale: string)
    { }

  ngOnInit() {
    this.FiltredCheckList=this.checkList;
    this.FiltredCheckListGT =this.checkList;
    this.FiltredCheckListPL =this.checkList;
    this.FiltredCheckListTTC =this.checkList;

    this.getCountries();
    this.getCalamityStatus();
    this.getCalamityId();
    this.initForm ();
    CALAMITY_KIND_DATA.forEach((element) => {
      this.calamityKindGrid.push(this.translateService.instant(element.text));
    });
    this.FiltredCalamityKindGrid =this.calamityKindGrid.sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1);
    if (this.calamityId != null || this.calamityId != undefined ){
      this.getCalamity();
      this.getTotalDossiersByCalamity();
    }
  }

  handleFilterKindCalamity(value) {
    this.FiltredCalamityKindGrid = this.calamityKindGrid.filter(
      (s) => s.toLowerCase().indexOf(value.toLowerCase()) != -1
    );
  }

  getDate(date) {
    return this.getLocaleDate(date);
  }
  getLocaleDate(date: Date) {
    if (date != null && (this.isIsoDate(date.toString()) || date.toString().indexOf('GMT') == -1)) {
      return this.intakeService.getLocalDate(date);
    }
    return date;
  }

  isIsoDate(dateStringToCompare) {
    return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
  }

  getDateFormat() {
    this.localDate = getLocaleTimeFormat(this.locale, FormatWidth.Short);
  }

  getDateFromCode(code: string, city: string) {
    if(code == null)
      return null;
    var zone = moment.tz.zonesForCountry(code);
    let cityvalue = cityTimezones.lookupViaCity(city);
    var convertedDate = null;
    try {
      if(cityvalue.length > 0)
          convertedDate = moment(new Date()).tz(cityvalue[0].timezone).format("HH:mm");
      else
          convertedDate = moment(new Date()).tz(zone[0]).format("HH:mm");
    }
    catch(error) {
      convertedDate = moment(new Date()).tz(zone[0]).format("HH:mm");
    }
    return convertedDate;
  }

  initForm (){
    this.calamityForm = this.fb.group(new CalamityModel());
    this.calamityForm.controls["calName"].setValidators([Validators.required]);
    this.calamityForm.controls["calKind"].setValidators([Validators.required]);
    this.calamityForm.controls["calStatusNavigation"].setValidators([Validators.required]);
    this.calamityForm.controls["calSosinternationalCoordinatingAlarmcenter"].setValidators([Validators.required]);
    this.calamityForm.controls["calCountry"].setValidators([Validators.required]);
    this.calamityForm.controls["calLocation"].setValidators([Validators.required]);
    this.calamityForm.updateValueAndValidity();
  }

  getCalamityId(){
    this.calamityService.calId$.pipe(takeUntil(this._subject$))
    .subscribe(res=> {
       this.calamityId=res;
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_CALAMITY_BY_ID");
    }
    );
  }

  getCountries(){
    let getCountrytUrl: string = `Country/Get`;
    this.commonService
    .getData(getCountrytUrl, this.serverUrlSlot1,true)
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.countries=data;
      if(this.calamityId != null && this.calamityId != null){
        let calamityCountry = this.countries.find(c=>c.id == this.calamityObject.calCountry);
        if(calamityCountry != undefined && calamityCountry != null)
        {
          this.calamityForm.controls["calCountry"].setValue(calamityCountry);
          this.getDateFromCode(calamityCountry.id, this.calamityObject.calLocation );
          let geocoder = new google.maps.Geocoder();
          let that = this;
          geocoder.geocode({ 'address': calamityCountry.name + " " +this.calamityObject.calLocation }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              that.calamityLatitude =results[0].geometry.location.lat();
              that.calamityLongitude =results[0].geometry.location.lng();
              that.cd.detectChanges();
            }
          });
        }
      }
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_COUNTRIES");
    }
    );
  }

  getTotalDossiersByCalamity(){
    let GetDossierUrl: string =
            `Dossier/GetDossiersByCalamityId/` + this.calamityId ;
          this.commonService
            .getData(GetDossierUrl, this.serverUrlSlot1)
            .pipe(takeUntil(this._subject$))
            .subscribe((res: any[]) => {
              this.calamityForm.controls["calTotalDossiers"].setValue(res.length);
              this.calamityForm.controls["calTotalDossiers"].disable();
              this.calamityForm.controls["calTotalDossiers"].updateValueAndValidity();
            },
            (error) => {
                this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIERS_FOR_CALAMITY");
            }
            );
  }

  getCalamityStatus(){
    this.calamityStatusService.getCalamityStatusByCulture(this.translateService.currentLang)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {​​​​​​​​
        this.calamityStatusGrid =  data;
        this.FiltredCalamityStatusGrid=this.calamityStatusGrid.sort((a, b) => a.casLongName.toLowerCase() > b.casLongName.toLowerCase() ? 1 : -1);
        if(this.calamityId == null || this.calamityId == undefined){
          let calamity = this.calamityStatusGrid.find(c=>c.casCode == "OPN");
          this.calamityForm.controls["calStatusNavigation"].setValue(calamity);
          this.calamityForm.controls["calStatusNavigation"].disable();
        }
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.GET_CALAMITY_STATUS_BY_CULTURE");
      }
      ​​​​​​​​);
  }

  handleFilterSOS(value) {
    this.FiltredCheckList = this.checkList.filter(
      (s) => s.toLowerCase().indexOf(value.toLowerCase()) != -1
    );
  }
  handleFilterGroupTravel(value) {
    this.FiltredCheckListGT = this.checkList.filter(
      (s) => s.toLowerCase().indexOf(value.toLowerCase()) != -1
    );
  }
  handleFilterPassengerList(value) {
    this.FiltredCheckListPL = this.checkList.filter(
      (s) => s.toLowerCase().indexOf(value.toLowerCase()) != -1
    );
  }
  handleFilterTeamTowards(value) {
    this.FiltredCheckListTTC = this.checkList.filter(
      (s) => s.toLowerCase().indexOf(value.toLowerCase()) != -1
    );
  }
  handleFilterStatus(value) {
    this.FiltredCalamityStatusGrid = this.calamityStatusGrid.filter(
      (s) => s.casLongName.toLowerCase().indexOf(value.toLowerCase()) != -1
    );
  }

  addCalamity(){
    this.calamityObject = this.calamityForm.value;
    this.calamityObject.calCountry= this.calamityForm.value.calCountry.id;
    this.calamityObject.calStatusNavigation = this.calamityForm.controls["calStatusNavigation"].value;
    if(this.location!=undefined)
      this.calamityObject.calLocation = this.location;
    if(this.calamityId!= undefined && this.calamityId != null){
      this.calamityObject.calId= this.calamityId;
      this.calamityService
      .update(this.calamityObject)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.cedNotificationService.success("NOTIFICATIONS.DATA_UPDATED")
        this.router.navigate(["/calamity/calamityList"]);
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.UPDATE_CALAMITY_ACTION");
      });
    } else {
      this.calamityService
      .save(this.calamityObject)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.cedNotificationService.success("NOTIFICATIONS.DATA_UPDATED")
        this.router.navigate(["/calamity/calamityList"]);
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.INSERT_CALAMITY_ACTION");
      });
    }
   }

  getCalamity(){
    this.calamityService
    .getOneById(this.calamityId)
    .pipe(takeUntil(this._subject$))
    .subscribe((data: CalamityModel) => {
      this.calamityObject = data ;
      data.calFrom = this.getDate(data.calFrom);
      data.calTill = this.getDate(data.calTill);
      this.getCountries();
      this.calamityForm.patchValue(data);
      this.calamityForm.updateValueAndValidity();
    });
  }

  public handleFilterCountries(value) {

    this.filteredCountries = this.countries.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
    if (this.filteredCountries.length > 0) {
      this.calamityForm.patchValue({
        calCountry: this.filteredCountries[0],
      });
    }
  }

  changeCity(event){
    if(event!=undefined && event!=null){
      const locality_array = event.address_components.filter(function (
        address_component
      ) {
        return address_component.types.includes("locality");
      });
      const locality = locality_array.length ? locality_array[0].long_name : "";
      const country_array = event.address_components.filter(function (
        address_component
      ) {
        return address_component.types.includes("country");
      });
      const country = country_array.length ? country_array[0].long_name : "";
      this.handleFilterCountries(country);
      var localTime = this.getDateFromCode(this.calamityForm.controls.calCountry.value.id, locality);
      this.calamityForm.patchValue({
        calLocalTime: localTime,
      });
      this.calamityObject.calLocation = event.name;
      this.location = event.name;
      let calamityCountry;
      if(this.calamityForm.controls["calCountry"].valid){
        calamityCountry = this.calamityForm.controls["calCountry"].value.name;
      } else {
        calamityCountry ="";
      }
      let geocoder = new google.maps.Geocoder();
      let that = this;
      geocoder.geocode({ 'address': calamityCountry +event.name }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          that.calamityLatitude =results[0].geometry.location.lat();
          that.calamityLongitude =results[0].geometry.location.lng();
          that.cd.detectChanges();
        }
      });
    }
  }

  changeTeamTowardsCalamity(event){
    if(event != "Yes"){
      this.calamityForm.controls["calFrom"].setValue(new Date ());
      this.calamityForm.controls["calTill"].setValue(new Date ());
    }
  }

  changeSOS(event){
    if(event != "Yes"){
      this.calamityForm.controls["calGroupTravel"].setValue(null);
      this.calamityForm.controls["calPassengerList"].setValue(null);
      this.calamityForm.controls["calLocalAlarmcenter"].setValue(null);
      this.calamityForm.controls["calTeamTowardsCalamity"].setValue(null);
      this.calamityForm.controls["calFrom"].setValue(new Date ());
      this.calamityForm.controls["calTill"].setValue(new Date ());
    }
  }
  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }

}